const breakpoints = {
    xs: 0,
    sm: 544,
    md: 769,
    lg: 992,
    xl: 1200,
};

export function generateIsOverBreakpoint(breakpointsArray) {
    return (breakpoint) => $(window).width() >= breakpointsArray[breakpoint];
}

export const isOverBreakpoint = generateIsOverBreakpoint(breakpoints);

export function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

export function getCookie(name) {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(';');
    const searchedCookie = cookies.find((cookie) => cookie.trim().indexOf(cookieName) === 0);
    return searchedCookie ? searchedCookie.trim().substring(cookieName.length) : null;
}

export function refreshKlarna($selector, newTotalAmount) {
    // eslint-disable-next-line no-undef
    if (typeof window.Klarna !== 'undefined' && window.Klarna.OnsiteMessaging) {
        $selector.attr('data-purchase-amount', newTotalAmount);
        // eslint-disable-next-line no-undef
        window.Klarna.OnsiteMessaging.refresh();
    }
}

export function hideOnBackgroundClick(targetClass, callbackFunction) {
    $('.modal-background').on('click', (e) => {
        if ($(e.currentTarget).hasClass(targetClass)) {
            callbackFunction();
        }
    });
}

export function getHeaderHeight() {
    const headerHeight = $('header.main-header').outerHeight();
    $(':root').css('--header-height', `${headerHeight}px`);
    const navbarHeaderHeight = $(
        'header.main-header .navbar-header',
    ).outerHeight();
    $(':root').css('--navbar-header-height', `${navbarHeaderHeight}px`);
}

export function replaceQueryParam(url, paramName, paramValue) {
    if (!paramValue) return url;
    const baseUrl = url.split('?')[0]; // Extract base URL
    const baseParams = url.split('?')[1] || '';
    const urlParams = new URLSearchParams(baseParams);
    urlParams.set(paramName, paramValue);
    return decodeURIComponent(`${baseUrl}?${urlParams.toString()}`);
}

export function triggerRedirectCountryModal() {
    const $redirectModal = $('#redirectCountry-modal');
    if (
        $redirectModal.length > 0
        && !getCookie('hide_redirect_country_modal')
    ) {
        $redirectModal.modal('show');
        $redirectModal.on('hidden.bs.modal', () => {
            setCookie('hide_redirect_country_modal', true, 30);
        });
    }
}

export function onExternalSiteRedirectModal() {
    const $externalSiteModal = $('#redirectExternalSite-modal');
    if ($externalSiteModal.length > 0) {
        $externalSiteModal.on('show.bs.modal', (e) => {
            $externalSiteModal
                .find('#redirect-link[href]')
                .attr('href', e.relatedTarget.href);
        });
    }
}

export function blurOnModalHide() {
    $(document).on('hide.bs.modal', '.modal', () => {
        if (document.activeElement) {
            document.activeElement.blur();
        }
    });
}
